import {useEffect, useMemo, useState} from 'react';
import { Grid } from '@material-ui/core';
import { HeaderParameters } from '../components';
import { useCompany } from 'contexts/CompanyContext';
import {toastMessages} from "config/constants";
import BillApi from 'services/api/bill';
import billsLogo from '_assets/parameters/bills.svg';
import DataTable from "components/DataTable";
import DataTableExportToolbar from "components/DataTableExportToolbar";
import moment from 'moment';
import toast from "react-hot-toast";
import useStyles from './styles';

moment.locale('fr');

const getState = (state) => {
  switch (state) {
    case 'pending':
      return 'En attente de paiement';
    case 'paid':
      return 'Payée';
    case 'incident':
      return 'Incident';
    default:
      return 'Inconnu';
  }
}

const headCells = [
  { id: 'order_number', label: 'Numéro de commande', sortable: true },
  { id: 'source', label: 'Emetteur', sortable: true },
  { id: 'creation_date', label: "Date d'émission", sortable: true },
  { id: 'amount_before_tax', label: 'Montant HT', sortable: true },
  { id: 'total_amount', label: 'Montant TTC', sortable: true },
  { id: 'balance', label: 'Solde', sortable: false },
  { id: 'state', label: 'Statut', sortable: false },
];

function Bills() {
  const classes = useStyles();
  const { currentCompany } = useCompany();

  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);

    const [searchValue, setSearchValue] = useState('');
    const filteredData = useMemo(() => searchValue ?
        bills.filter(v => Object.values(v).map(v => String(v)).find(f => f.toLowerCase().includes(searchValue))) :
        bills, [bills, searchValue]);

  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    BillApi.listBills(currentCompany?.id).then(({ data }) => {
      const formattedBills = data.map(bill => ({
        ...bill,
        amount_before_tax: `${Number(bill.amount_before_tax).toFixed(2)} €`,
        balance: `${Number(bill.balance).toFixed(2)} €`,
        creation_date: moment(bill.creation_date).format('DD MMM YYYY'),
        state: getState(bill.state),
        total_amount: `${Number(bill.total_amount).toFixed(2)} €`,
      }));
      setBills(formattedBills);
      setLoading(false);
    });
  }, [currentCompany.id]);

  const handleExport = (selectedData, format, useSelected) => {
    if (exporting) return;

    setExporting(true);

    let billIds;
    if (useSelected) {
      billIds = selectedData.sort((a, b) => a - b);
    } else {
      billIds = bills.map(b => b.id);
    }

    BillApi.exportBills(currentCompany?.id, format, {ids: billIds})
        .then((result) => {
          let blob;
          if (format === 'csv') blob = new Blob(['\ufeff' + result], {type: 'text/csv;'});
          else blob = new Blob([result], {type: 'application/pdf'});

          const filename = `Maia Partner - Factures.${format}`;

          if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
          } else {
            let link = document.createElement('a');
            if (link.download !== undefined) {
              link.setAttribute('href', URL.createObjectURL(blob));
              link.setAttribute('download', filename);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }

          setExporting(false);
        })
        .catch(() => {
          toast.error(toastMessages.error.EXPORT_BILL);
          setExporting(false);
        });
  }
  return (
    <Grid className={classes.root} container justifyContent='center' spacing={3}>
      <HeaderParameters image={billsLogo} noMargin text='Facturation'/>

      <Grid item xs={12}>
        <DataTable
            data={filteredData}
            headCells={headCells}
            loading={loading}
            checkbox
            ToolbarComponent={DataTableExportToolbar}
            toolbarProps={{
              onSearchChange: (event) => setSearchValue(event.target.value),
              onExport: (data,format, useSelected) => handleExport(data, format, useSelected),
              nbSelectedItems: 0,
            }}
        />
      </Grid>
    </Grid>
  );
}

export default Bills;
